import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, getDocs, query, where, orderBy } from 'firebase/firestore';
import { db } from '../firebase';
import FeaturedAdsCarousel from '../components/FeaturedAdsCarousel';
import PopupAd from '../components/PopupAd';
import './CategoriesPage.css';

function CategoriesPage() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const q = query(
          collection(db, 'categories'),
          where('isActive', '==', true),
          orderBy('order')
        );
        const querySnapshot = await getDocs(q);
        const categoriesData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setCategories(categoriesData);
      } catch (error) {
        console.error('Error fetching categories:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
        <p>Loading categories...</p>
      </div>
    );
  }

  return (
    <div className="categories-page">
      <div className="categories-hero">
        <img src="https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=2000&q=90" alt="" className="hero-bg-image" />
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Browse Categories</h1>
          <p>Discover businesses and services across the Cook Islands</p>
        </div>
      </div>
      
      <FeaturedAdsCarousel />
      <PopupAd />
      
      <div className="categories-grid">
        {categories.map(category => (
          <Link
            key={category.id}
            to={`/category/${category.id}`}
            className="category-card-new"
          >
            {category.bannerUrl || category.imageUrl ? (
              <div className="category-image-wrapper with-image">
                <img 
                  src={category.bannerUrl || category.imageUrl} 
                  alt={category.name} 
                  className="category-image"
                />
              </div>
            ) : (
              <div className="category-image-wrapper">
                {category.icon || category.name.charAt(0)}
              </div>
            )}
            <div className="category-info">
              <h3>{category.name}</h3>
              {category.description && <p>{category.description}</p>}
            </div>
            <div className="category-arrow">→</div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default CategoriesPage;
